<script>
  import { onMount } from 'svelte'
  import Modal from '../components/Modal.svelte'
  import ModalContent from './Content/ModalContent'
  import FontLoader from '../components/FontLoader.svelte'
  import configModule from '../config'
  import { getFontFamily, isMobileBrowser } from '../utils'
  import fontsMod from '../fonts'
  import loggerMod from '../loader/log'

  export let settingsResponse

  let settings
  let reviewsText
  let buttonColor
  let buttonTextColor
  let neptuneAlignment
  let showOnDevice
  let fontType
  let showMobileView
  let isMobile
  let isMobileScreenWidth
  let width

  const fonts = fontsMod()
  const log = loggerMod()
  const config = configModule()

  // use neptune legacy widget id to allow existing display:none styles to work on it
  const neptuneWidgetId = config.legacyNeptuneWidgetDocumentId

  $: if (width <= 375) {
    isMobileScreenWidth = true
  } else {
    isMobileScreenWidth = false
  }

  onMount(async () => {
    try {
      settings = settingsResponse.data
      reviewsText = settings.translations.button_state
      buttonColor = settings.widget_settings.general_settings.primary_color
      buttonTextColor =
        settings.widget_settings.general_settings.button_text_color
      neptuneAlignment = settings.widget_settings.neptune.alignment
      isMobile = isMobileBrowser()
      fontType = settings.widget_settings.general_settings.font_type
      showOnDevice =
        (isMobile && settings.widget_settings.neptune.mobile_visiblity) ||
        (!isMobile && settings.widget_settings.neptune.desktop_visiblity)
      showMobileView = settings.widget_settings.neptune.show_mobile_view
    } catch (error) {
      log.error(error)
    } finally {
      !showOnDevice &&
        config.isPreview &&
        window.dispatchEvent(new Event(config.previewLoadedEvent))
    }
  })
</script>

<style>
  :global(#kudobuzz_neptune_widget, #kudobuzz_neptune_widget *) {
    font-family: var(--fontFamily);
  }
  .neptune-btn__wrapper {
    margin: 20px;
  }

  .neptune-btn {
    width: auto;
    color: #fff;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
    border: none;
    font-size: 14px;
    line-height: 17px;
    font-family: inherit;
    position: fixed;
    z-index: 1000000;
  }

  .left {
    -webkit-transform-origin: 0 50%;
    -webkit-transform: rotate(-90deg) translate(-50%, 50%);
    -moz-transform-origin: 0 50%;
    -moz-transform: rotate(-90deg) translate(-50%, 50%);
    -ms-transform-origin: 0 50%;
    -ms-transform: rotate(-90deg) translate(-50%, 50%);
    -o-transform-origin: 0 50%;
    -o-transform: rotate(-90deg) translate(-50%, 50%);
    transform-origin: 0 50%;
    transform: rotate(-90deg) translate(-50%, 50%);
    left: 0;
    top: 50%;
  }

  .bottom_left {
    bottom: 0;
    top: inherit !important;
    left: 20px;
    position: fixed;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
  }

  .bottom_center {
    bottom: 0 !important;
    top: inherit !important;
    left: 42%;
    position: fixed;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
  }

  .bottom_right {
    bottom: 0;
    top: inherit !important;
    right: 20px;
    position: fixed;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
  }

  .right {
    -webkit-transform-origin: 100% 50% 0;
    -webkit-transform: rotate(90deg) translate(50%, 50%);
    transform-origin: 100% 50% 0;
    transform: rotate(90deg) translate(50%, 50%);
    right: 0;
    position: fixed;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
    top: 50%;
  }

  .top_center {
    bottom: inherit !important;
    top: 0 !important;
    left: 42%;
    position: fixed;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
  }

  .top_left {
    bottom: inherit !important;
    top: 0 !important;
    left: 0;
    position: fixed;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
  }

  .top_right {
    bottom: inherit !important;
    top: 0 !important;
    right: 0;
    position: fixed;
    padding: 15px 20px;
    text-transform: uppercase;
    opacity: 1;
    text-decoration: none;
    display: table;
    cursor: pointer;
  }

  .neptune-btn:focus {
    outline: none;
  }

  .kudobuzz_star_icon::before {
    content: '\e800';
  }
</style>

<svelte:window bind:innerWidth={width} />
{#if showOnDevice}
  <FontLoader {fontType} />
  <div
    id={neptuneWidgetId}
    style={fonts[fontType] ? `--fontFamily: ${getFontFamily(fonts[fontType])};` : ''}>
    <Modal>
      <ModalContent name="ReviewAndQuestion" {settings}>
        <div class="$style.wrapper">
          <div class="$style.neptune-btn__wrapper">
            <button
              class="$style.neptune-btn {neptuneAlignment}"
              style="background-color: {buttonColor}; color: {buttonTextColor};">
              {#if (isMobile && showMobileView) || (isMobileScreenWidth && showMobileView)}
                <span class="kudobuzz_star_icon kudobuzz_icons" />
              {:else}
                <span class="kudobuzz_star_icon kudobuzz_icons" />
                &nbsp;{reviewsText}&nbsp;
                <span class="kudobuzz_star_icon kudobuzz_icons" />
              {/if}
            </button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  </div>
{/if}
